import { useState, useEffect } from "react";
import { SubmitButton } from "../../components/Input";
import { useNavigate, useParams } from "react-router-dom";
import StateManagedSelect from "react-select";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const fieldList = [
  { value: "", label: "- Select -" },
  { value: "$buysell", label: "BUY/SELL" },
  { value: "$service_name", label: "Service Name" },
  { value: "$symbol", label: "Symbol" },
  { value: "$duration", label: "Duration" },
  { value: "$quantity", label: "Quantity" },
  { value: "$entry_price", label: "Entry Price" },
  { value: "$target1", label: "Target 1" },
  { value: "$target2", label: "Target 2" },
  { value: "$stoploss", label: "StopLoss" },
  { value: "$profit", label: "Profit" },
  { value: "$dated", label: "Dated" },
  { value: "$cmp", label: "Current Market Price" },
  { value: "$comments", label: "Comments" },
  {
    value: "$saveonpage",
    label:
      "Save On Page String Ex. TGT1 Modified to Price / TGT2 Modified to Price / Stoploss Modified to Price",
  },
  { value: "$tradenowurl", label: "Trade Now Url" },
];

const typeArr = { 1: "Text", 2: "Image", 3: "Video", 4: "File" };

const deeplinkOptions = [
  { value: "", label: "- Select -" },
  { value: "general", label: "General" },
  { value: "portfolio", label: "Portfolio" },
  { value: "portfolio-detail", label: "Portfolio - Detail" },
  { value: "streetview", label: "Streetview" },
];

const TemplatePortfolioForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const [loading, setLoading] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [message, setMessage] = useState("");
  const [notificationTitle, setNotificationTitle] = useState("");
  const [notification, setNotification] = useState("");
  const [whatsappCampaign, setWhatsappCampaign] = useState("");
  const [templateType, setTemplateType] = useState("1");
  const [wpFileName, setWpFileName] = useState("");
  const [file, setFile] = useState(null);
  const [oldFileUrl, setOldFileUrl] = useState("");
  const [paramList, setParamList] = useState([]);
  const [paramEmailList, setParamEmailList] = useState([]);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailAttachmentName, setEmailAttachmentName] = useState("");
  const [emailAttachmentFile, setEmailAttachmentFile] = useState("");
  const [oldAttachmentFileUrl, setOldAttachmentFileUrl] = useState("");
  const [deeplink, setDeeplink] = useState("");

  useEffect(() => {
    if (id) fetchTemplateData(id);
  }, [id]);

  const fetchTemplateData = async (id) => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}settings/portfolio/template/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data.data;

      setTemplateName(data.template_name || "");
      setMessage(data.message || "");
      setNotificationTitle(data.notification_title || "");
      setNotification(data.notification || "");
      setWhatsappCampaign(data.whatsapp_campaign || "");
      setTemplateType(data.template_type?.toString() || "1");
      setWpFileName(data.file_name || "");
      setOldFileUrl(data.file_url || "");
      setDeeplink({ value: data.deeplink || "", label: data.deeplink || "- Select -" });

      if (data.whatsapp) {
        const list = data.whatsapp.split(",").map((val) => {
          const found = fieldList.find((f) => f.value === val);
          return found || { value: val, label: val };
        });
        setParamList(list);
      }

      if (data.email_message) {
        const list = data.email_message.split(",").map((val) => {
          const found = fieldList.find((f) => f.value === val);
          return found || { value: val, label: val };
        });
        setParamEmailList(list);
      }

      setEmailSubject(data.email_subject || "");
      setEmailAttachmentName(data.attachment_name || "");
      setEmailAttachmentFile(data.attachment_url || "");
      setOldAttachmentFileUrl(data.attachment_url || "");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // SMS/Whatsapp param handlers
  const handleAddParam = () => setParamList([...paramList, { value: "", label: "- Select -" }]);
  const handleDeleteParam = (index) => setParamList(paramList.filter((_, i) => i !== index));
  const handleParamChange = (selectedOption, index) => {
    const updated = [...paramList];
    updated[index] = selectedOption;
    setParamList(updated);
  };

  // Email param handlers
  const handleAddEmailParam = () => setParamEmailList([...paramEmailList, { value: "", label: "- Select -" }]);
  const handleDeleteEmailParam = (index) => setParamEmailList(paramEmailList.filter((_, i) => i !== index));
  const handleEmailParamChange = (selectedOption, index) => {
    const updated = [...paramEmailList];
    updated[index] = selectedOption;
    setParamEmailList(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("templateName", templateName);
    formData.append("message", message);
    formData.append("notificationTitle", notificationTitle);
    formData.append("notification", notification);
    formData.append("whatsappCampaign", whatsappCampaign);
    formData.append("templateType", templateType);
    formData.append("wpFileName", wpFileName);
    formData.append("file", file || "");
    formData.append("whatsapp", paramList.map((p) => p.value).join(","));
    formData.append("email_subject", emailSubject);
    formData.append("email_attachment_name", emailAttachmentName);
    formData.append("email_attachment", emailAttachmentFile);
    formData.append("email_message", paramEmailList.map((p) => p.value).join(","));
    formData.append("deeplink", deeplink.value);

    try {
      setLoading(true);
      const url = id
        ? `${API_URL}settings/portfolio/template/save?id=${id}`
        : `${API_URL}settings/portfolio/template/save`;

      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        showToast.success(res.data.message);
        navigate("/Settings/TemplatePortfolio");
      }
    } catch (err) {
      console.error(err);
      showToast.error("Error saving template");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="page-container page-header-fixed page-sidebar-fixed fade in mt-5">
      <div className="panel panel-default with-rounded-corner with-shadow">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          {/* Template Portfolio SMS */}
          <div className="panel-heading">
            <span className="panel-title">Edit Template Portfolio SMS</span>
          </div>
          <div className="panel-body pb-1">
            <div className="row">
              <div className="col-md-4 mb-2">
                <label>Template Name</label>
                <input type="text" className="form-control" value={templateName} disabled />
              </div>
              <div className="col-md-4 mb-2">
                <label>Select Data</label>
                <StateManagedSelect
                  options={fieldList}
                  onChange={(opt) => opt && setMessage((prev) => prev + opt.value)}
                />
              </div>
              <div className="col-md-4 mb-2">
                <label>Deeplink To</label>
                <StateManagedSelect
                  options={deeplinkOptions}
                  value={deeplink}
                  onChange={(opt) => setDeeplink(opt)}
                />
              </div>
              <div className="col-md-12 mb-2">
                <label>Message</label>
                <textarea className="form-control" value={message} onChange={(e) => setMessage(e.target.value)} />
              </div>
            </div>
          </div>

          {/* Push Notification */}
          <div className="panel-heading pt-0">
            <span className="panel-title">Edit Template Portfolio Push Notification</span>
          </div>
          <div className="panel-body">
            <div className="row">
              <div className="col-md-8 mb-2">
                <label>Select Data</label>
                <StateManagedSelect
                  options={fieldList}
                  onChange={(opt) => opt && setNotificationTitle((prev) => prev + opt.value)}
                />
              </div>
              <div className="col-md-12 mb-2">
                <label>Push Notification Title</label>
                <textarea
                  className="form-control"
                  value={notificationTitle}
                  onChange={(e) => setNotificationTitle(e.target.value)}
                />
              </div>
              <div className="col-md-8 mb-2">
                <label>Select Data</label>
                <StateManagedSelect
                  options={fieldList}
                  onChange={(opt) => opt && setNotification((prev) => prev + opt.value)}
                />
              </div>
              <div className="col-md-12 mb-2">
                <label>Push Notification</label>
                <textarea className="form-control" value={notification} onChange={(e) => setNotification(e.target.value)} />
              </div>
              <div className="col-md-5 mb-2">
                <label>Upload File</label>
                <input type="file" className="form-control" onChange={(e) => setFile(e.target.files[0])} />
              </div>
              {oldFileUrl && (
                <div className="col-md-3">
                  <img src={oldFileUrl} alt="Preview" width="150px" />
                </div>
              )}
            </div>
          </div>

          {/* Whatsapp */}
          <div className="panel-heading pt-0">
            <span className="panel-title">Edit Template Portfolio Whatsapp</span>
          </div>
          <div className="panel-body">
            <div className="row">
              <div className="col-md-4 mb-2">
                <label>Campaign Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={whatsappCampaign}
                  onChange={(e) => setWhatsappCampaign(e.target.value)}
                />
              </div>
              <div className="col-md-5 mb-2">
                <label>Template Type</label>
                <select className="form-control" value={templateType} onChange={(e) => setTemplateType(e.target.value)}>
                  {Object.entries(typeArr).map(([key, val]) => (
                    <option key={key} value={key}>
                      {val}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {templateType !== "1" && (
              <div className="row w-100 d-flex gap-2 align-items-end">
                <div className="col-md-4 mb-2">
                  <label>File Name</label>
                  <input type="text" className="form-control" value={wpFileName} onChange={(e) => setWpFileName(e.target.value)} />
                </div>
                <div className="col-md-5 mb-2">
                  <label>Upload File</label>
                  <input type="file" className="form-control" onChange={(e) => setFile(e.target.files[0])} />
                </div>
                {oldFileUrl && (
                  <div className="col-md-3">
                    <img src={oldFileUrl} alt="File Preview" width="50px" />
                  </div>
                )}
              </div>
            )}

            {/* Whatsapp param list */}
            <div className="row">
              <table className="table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paramList.map((param, i) => (
                    <tr key={i}>
                      <td>
                        <StateManagedSelect
                          options={fieldList}
                          value={param}
                          onChange={(opt) => handleParamChange(opt, i)}
                        />
                      </td>
                      <td>
                        <button type="button" className="btn btn-danger" onClick={() => handleDeleteParam(i)}>
                          <i className="fa fa-times" /> Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan="2">
                      <button type="button" className="btn btn-success" onClick={handleAddParam}>
                        + Add Field
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Email */}
          <div className="panel-heading pt-0">
            <span className="panel-title">Edit Template Portfolio Email</span>
          </div>
          <div className="panel-body">
            <div className="row">
              <div className="col-md-12 mb-2">
                <label>Subject</label>
                <input type="text" className="form-control" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} />
              </div>
              <div className="col-md-6 mb-2">
                <label>Attachment Name</label>
                <input type="text" className="form-control" value={emailAttachmentName} onChange={(e) => setEmailAttachmentName(e.target.value)} />
              </div>
              <div className="col-md-3 mb-2">
                <label>Attachment File</label>
                <input type="file" className="form-control" onChange={(e) => setEmailAttachmentFile(e.target.files[0])} />
              </div>
              {oldAttachmentFileUrl && (
                <div className="col-md-3 mb-2">
                  <a href={oldAttachmentFileUrl} download className="btn btn-primary">
                    <i className="fa fa-download" /> Download
                  </a>
                </div>
              )}
            </div>

            {/* Email param list */}
            <div className="row">
              <table className="table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paramEmailList.map((param, i) => (
                    <tr key={i}>
                      <td>
                        <StateManagedSelect
                          options={fieldList}
                          value={param}
                          onChange={(opt) => handleEmailParamChange(opt, i)}
                        />
                      </td>
                      <td>
                        <button type="button" className="btn btn-danger" onClick={() => handleDeleteEmailParam(i)}>
                          <i className="fa fa-times" /> Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan="2">
                      <button type="button" className="btn btn-success" onClick={handleAddEmailParam}>
                        + Add Field
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-md-12">
            <SubmitButton pageBack={"/Settings/TemplatePortfolio"} handleSubmit={handleSubmit} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default TemplatePortfolioForm;
